import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DeRegisterdDeviceUseCase extends BaseUseCase {
    constructor(deRegisterdDeviceRep) {
        super();
        this.deRegisterdDeviceRep = deRegisterdDeviceRep;
    }
    async fetchResult(req) {
        return await this.deRegisterdDeviceRep.deRegisterDeviceDetailsData(req);
    }
}
export default DeRegisterdDeviceUseCase;
